import ReactDOM from 'react-dom/client';
import { track } from 'c9-tracking';
import App from './app/App';
import logClient, { LogLevels } from 'c9-js-log-client';
import './assets/styles/common.css';
import { AppConfigService } from './common/services/AppConfigService';
import { AppContextProvider } from './common/context/AppContextProvider';
import { BrowserRouter as Router } from 'react-router-dom';

const context: any = window || {};
const pageType = context.location.pathname.indexOf('kvittering') !== -1 ? 'receipt' : 'app';
context.OnsaContent = (function () {
    function boostrapApplication(boostrapElement: HTMLElement) {
        const baseName = boostrapElement.getAttribute('data-basename');
        const dataApiAwsHost = boostrapElement.getAttribute('data-apiAwsHost');
        const config = AppConfigService(baseName, dataApiAwsHost);
        const c9log = logClient(window.topContext.config.getEndpointConfig().logger, config.appName, LogLevels.debug);
        c9log.debug(`Starting up application ${config.appName}, basename ${config.baseName}`, 'bootstrap');
        track.ready(true);
        function WrapAppWithContext() {
            return (
                <Router basename={config.baseName}>
                    <AppContextProvider config={config} c9log={c9log} pageType={pageType}>
                        <App config={config} c9log={c9log} pageType={pageType} />
                    </AppContextProvider>
                </Router>
            );
        }

        ReactDOM.createRoot(boostrapElement).render(<WrapAppWithContext />);
    }
    return boostrapApplication;
})();

window.addEventListener('load', function () {
    try {
        new context.OnsaContent(document.getElementsByTagName('onsa-content').item(0));
    } catch (e) {
        return <div>{`error occurred ${e}`}</div>;
    }
});
